export default __webpack_public_path__ + "static/media/plus.4320f8bb.svg";